import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {
    getAuthHeader, getItems, getLocalStorageItem,
    objectLang,
    setErrorWindow,
    setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {WindowPopup} from "../components/WindowPopup"
import {LinksClass} from "../components/LinksClass";

export const LinkDetailPage = () => {
    setLocalStorageItem('page', 'LinkDetailPage')

    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const [data, setData] = useState(null)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const linkId = useParams().id
    let lang = objectLang().language

    const getLink = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/link/detail/${linkId}`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            }

            const link = data.link
            const password = link.password
            if (password !== '') {
                link.password = atob(password)
            }
            setData({link: link, owner: data.owner})
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [auth, linkId, request])

    useEffect(() => {
        getLink().then()
    }, [getLink])

    // const updateHandler = () => {
    //     $('#share-checkbox').attr('disabled', false)
    //     $('#from').attr('disabled', false)
    //     $('#name').attr('disabled', false)
    //     $('#description').attr('disabled', false)
    //     $('#login').attr('disabled', false)
    //     $('#password').attr('disabled', false)
    //     $('.eye-detail').css('background-color', 'white')
    // }

    // const removeLinkHandler = (link) => {
    //     lang = objectLang().language
    //     const l = lang.lang
    //     setDataModal({
    //         title: lang.modal.warnings.title,
    //         desc: lang.modal.warnings.desc.deleteLink,
    //         btnCancel: lang.modal.warnings.btnCancel,
    //         btnOK: lang.modal.warnings.btnOK,
    //         clickOK: `replaceTo /${l}/link/remove/${link["_id"]}`,
    //         clickCancel: 'reload'
    //     })
    //     setAllowed(false)
    // }

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }

    return (
        <>
            <LinksClass
                auth={auth}
                documents={getLocalStorageItem('documents')}
                items={getItems(getLocalStorageItem('documents'))}
                rootFolder={auth.rootFolder}
            />
            <div className={'container'}>
                {!loading && data &&
                <WindowPopup
                    lang={lang}
                    title={lang.body.googlePropertiesPage.title}
                    data={{
                        link: data.link,
                        owner: data.owner,
                        typeData: 'link-properties',
                        thumb: new URLSearchParams(window.location.search).get('thumb') || '',
                        name: new URLSearchParams(window.location.search).get('name') || '',
                        ownerName: auth.nickName
                    }}
                />}
            </div>
        </>

    )
}
